module.exports = __webpack_public_path__ + "f9690b28f927669ce426a51e2ca0f9ac.png";